module.exports = __webpack_public_path__ + "assets/img/goConsumption.1529baa1.png";